import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { STATES } from './constants';

/**
 * STATES with display labels resolved from the `usStates` i18n
 * namespace (keyed by the two-letter value). Values — the backend
 * contract — never change; a missing key falls back to the English
 * label baked into STATES.
 */
export const useLocalizedStates = () => {
  const statesT = useSelector(state => state.i18n?.usStates);
  return useMemo(
    () => STATES.map(option => ({ ...option, label: statesT?.[option.value] || option.label })),
    [statesT]
  );
};
